import { ark } from "@ark-ui/react/factory";
import type { ComponentProps } from "react";
import { styled } from "@repo/styled-system/jsx";
import { inputAddon } from "@repo/styled-system/recipes";

export type InputAddonProps = ComponentProps<typeof InputAddon>;
export const InputAddon = styled(ark.div, inputAddon);
